const values = {
    "ARTICLE_REMITTANCES": "Envio de artículos",
    "NO_ARTICLE_REMITTANCES_TITLE": "No hay entregas de artículos!!!",
    "NO_ARTICLE_REMITTANCES_SUBTITLE": "Verifica si estas aplicando algún filtro",
}

export default values;